export const getFileExtension = file => file.name.split('.').pop().replace('/[^a-zA-Z0-9]/', '');

const EXTENSION_BLACKLIST = ['.exe', '.sh', '.svg'];
export const shouldRejectFile = file => EXTENSION_BLACKLIST.some(ext => file.name.endsWith(ext));
